import DataStorageUnit from '../data-storage-unit.js';

export const KB = 1024;
export const MB = 1024 * KB;
export const GB = 1024 * MB;
export const TB = 1024 * GB;
export const PB = 1024 * TB;
export const EB = 1024 * PB;
export const ZB = 1024 * EB;
export const YB = 1024 * ZB;

const getTotalBytes = (unit: DataStorageUnit): number => {
  switch (unit) {
    case DataStorageUnit.KB:
      return KB;
    case DataStorageUnit.MB:
      return MB;
    case DataStorageUnit.GB:
      return GB;
    case DataStorageUnit.TB:
      return TB;
    case DataStorageUnit.PB:
      return PB;
    case DataStorageUnit.EB:
      return EB;
    case DataStorageUnit.ZB:
      return ZB;
    case DataStorageUnit.YB:
      return YB;
    default:
      return 0;
  }
};

export default getTotalBytes;
